import { type FC, type ReactNode } from "react";
import { Box, styled, Typography } from "~/common/mui";
import LinearInfo from "~/features/configurator/Linear/components/LinearInfo";

export interface LabeledInputProps {
  children?: ReactNode;
  label: ReactNode;
  className?: string;
  hasError?: boolean;
  cutOverflow?: boolean;
  info?: string;
}

const InputWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
});

const Label = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$hasError" && prop !== "$cutOverflow",
})<{ $hasError?: boolean; $cutOverflow?: boolean }>(({ theme, $hasError, $cutOverflow }) => ({
  ...theme.typography.bodySmall,
  color: $hasError ? theme.palette.error.main : theme.palette.text.secondary,
  ...($cutOverflow && {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
}));

const LabeledInput: FC<LabeledInputProps> = (props) => {
  return (
    <InputWrapper className={props.className}>
      <Label
        variant="bodySmall"
        $hasError={props.hasError}
        $cutOverflow={props.cutOverflow}
        title={typeof props.label === "string" ? props.label : undefined}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {props.label}
          {props.info && <LinearInfo info={props.info} popupClassName={"scha__lc__external-content--shaft"} />}
        </Box>
      </Label>
      {props.children}
    </InputWrapper>
  );
};

export default LabeledInput;
